/**
 * Created by Barry on 1/29/2017.
 */

var $ = require('js/sw-jquery/sw-jquery');
var sw = require('js/lib/sw');
var ModelManager    = require('js/lib/models/ModelManager');
var pollingActions  = require('js/lib/actions/PollingInstances/actionCreators');
var POLLING_INSTANCE_CONSTANTS = {
  pollingInstanceViewSelector:  '[data-sw-polling-instance-view]'
};

$(document).ready(function() {

  $('body').on('click', '[data-sw-ip-match]', function(e) {
    var pathname = window.location.pathname;
    if (pathname === '/mymodels') {
      e.preventDefault();
      var $el = $(this);
      var action = $el.attr('data-sw-ip-match-action');
      var blacklistResourceId = $el.attr('data-sw-ip-match-blacklist-id');
      $.swAjax({
        url: '/upload?format=json',
        type: 'POST',
        dataType: 'json',
        data: { _method: action, blacklistResourceId : blacklistResourceId },
        success: function success(result) {
          var pollingInstance = result.message.pollingInstance;
          var title = pollingInstance.title;
          var pollingData = pollingInstance;
          var imageUrl = '';
          if (pollingData.images.length) {
            imageUrl = pollingData.images[0];
          }

          //hide current warning message
          $el.closest(POLLING_INSTANCE_CONSTANTS.pollingInstanceViewSelector).hide();

          // add new pollinginstance
          ModelManager.amdNewPollingInstance(title, function(pollingInstance) {
            sw.dispatch(pollingActions.pollingStatusInitiated(pollingInstance.cid, title));
            sw.dispatch(pollingActions.pollingStatusHydrated(pollingInstance.cid, pollingData.id, imageUrl, pollingData.title, pollingData.status, pollingData.description, pollingData.polling));
          }, true);

        },
        error: function error() {
          $el.closest(POLLING_INSTANCE_CONSTANTS.pollingInstanceViewSelector).hide();
        }
      });
    }
  });
});


